<template>
    <div class="creations-container">
        <div class="top">
            <div class="tabs">
                <div class="tab-item" :class="[currTab == 1 ? 'active':'']" @click="onTabClick(1)">我的笔记</div>
                <div class="tab-item" :class="[currTab == 2 ? 'active':'']" @click="onTabClick(2)">草稿箱({{temp_count}})</div>
            </div>
            <div class="right-box">
                <div class="sort-box">
                    <select v-model="query.sort" @change="onSortChange">
                        <option value="latest">最新发布</option>
                        <option value="likes">最多点赞</option>
                    </select>
                </div>
                <div class="search-box">
                    <input v-model="query.keyword" placeholder="搜索关键词搜索" type="text" @keyup.enter="onSearch" />
                    <img src="../../assets/images/icon-search-workbench.png" @click="onSearch" />
                </div>
            </div>
        </div>
        <div class="status-box" v-if="currTab == 1">
            <div :class="['status-item',{active:parseInt(query.status)===v.value}]" v-for="(v,k) in status_list" :key="`s`+k" @click="change_status(v.value)">
                {{v.name}} ({{v.count}})
            </div>
        </div>
        <div class="content-box">
            <div class="content-item" v-for="(item,index) in list" :key="`ll${index}`" @click.prevent.stop="onItemClick(item)">
                <div class="item-container" @click="onArticleDetail(item)">
                    <div class="cover-box">
                        <div v-if="item.is_top" class="top-flag">置顶</div>
                        <img :src="item.cover|default_img" alt="">
                        <div v-if="item.purview != 0" class="permission-status">{{item.permission_text}}</div>
                    </div>
                    <div class="content">
                        <div class="title"><span v-if="currTab == 1" :class="[item.status == 2 ? 'unpass' : item.status == 0 ? 'uncheck' :'']">{{ item.status|status_filter }}</span>{{ item.title ? item.title : '未命名'}}</div>
                        <div class="datetime">{{currTab == 1 ? '发布于：' : '编辑于：'}}{{currTab == 1 ? item.last_publish_time : item.last_edit_time}}</div>
                        <div class="count-box" v-if="currTab == 1">
                            <img src="../../assets/images/icon-views-creations.png"/>
                            <span>{{item.view_times}}</span>
                            <img src="../../assets/images/icon-comment-creations.png" />
                            <span>{{item.comment_count}}</span>
                            <img src="../../assets/images/icon-like-creations.png" />
                            <span>{{item.zan_count}}</span>
                            <img src="../../assets/images/icon-collect-creations.png" />
                            <span>{{item.collect_count}}</span>
                            <!-- <img src="../../assets/images/icon-share-creations.png" />
                            <span>0</span> -->
                        </div>
                        <!-- <div class="match-box" v-if="[1,3,5,6].includes(item) && currTab == 1">
                            <div class="match-text">
                                <img src="../../assets/images/icon-match-creations.png" />
                                <span>正在参加一个比赛比赛比赛比赛比赛比赛</span>
                            </div>
                        </div> -->
                        <div class="reason-box" v-if="item.reason && item.status == 2">
                            <div class="container">
                                <div class="reason-text">
                                   审核结果: {{ item.reason }}
                                </div>
                            </div>
                        </div>
                        <div class="last-edit-time" v-if="currTab == 2">
                            最后修改时间：{{item.last_edit_time}}
                        </div>
                        <div class="bottom-box">
                            <Poptip placement="bottom" trigger="hover" padding="8px 5px" popper-class="permission-box" :transfer="true" v-if="currTab == 1" @on-popper-show="onOpenSetting(item)" @on-popper-hide="onCancelSetting">
                                <template #content>
                                    <div class="permission-title">
                                        <img src="../../assets/images/icon-permission-lock.png"/>
                                        权限设置
                                    </div>
                                    <div class="permission-box">
                                        <div class="permission-item" @click="onSelectPermission(item, 0)">
                                            <div class="permission-item-text">公开可见</div>
                                            <Icon v-if="temp_purview == 0" type="md-checkmark" color="#ff5967" size="14"/>
                                        </div>
                                        <div class="permission-item" @click="onSelectPermission(item, 1)">
                                            <div class="permission-item-text">仅自己可见</div>
                                            <Icon v-if="temp_purview == 1" type="md-checkmark" color="#ff5967" size="14"/>
                                        </div>
                                        <div class="permission-item" @click="onSelectPermission(item, 2)">
                                            <div class="permission-item-text">仅互关好友可见</div>
                                            <Icon v-if="temp_purview == 2" type="md-checkmark" color="#ff5967" size="14"/>
                                        </div>
                                    </div>
                                    <div class="set-top-box">
                                        置顶 <i-switch v-model="temp_is_top" @on-change="onToggleTop" />
                                    </div>
                                </template>
                                <!--  -->
                                <div class="bottom-item" @click.prevent.stop>
                                    <img src="../../assets/images/icon-creations-setting.png"/>
                                    更多设置<Icon type="ios-arrow-down"/>
                                </div>
                            </Poptip>
                            <div class="bottom-item" @click.prevent.stop="onItemEdit(item)">
                                <img src="../../assets/images/icon-edit-creations.png"/>
                                编辑
                            </div>
                            <div class="bottom-item" @click.prevent.stop="onItemDelete(item)">
                                <img src="../../assets/images/icon-delete-creations.png" />
                                删除
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-container" v-if="show_page">
            <Page :total="total_page" :current="query.page" :page-size="query.limit" prev-text="上一页" next-text="下一页" @on-change="onPageChange"></Page>
        </div>
        <ArticleDetail ref="articleDetail" v-if="show_detail" @on-close="onCloseArticleDetail" :uuid="uuid"></ArticleDetail>
    </div>
</template>
<script>
import { DeletePosts, GetMyPostCount, GetMyPostList, SetPostPermission } from '@/api/social';
import ArticleDetail from '@/components/ArticleDetail';
import _ from 'lodash';
export default{
    data(){
        return{
            currTab:1,
            temp_count:0,
            total_count:0,
            query:{
                keyword:"",
                page:1,
                limit:15,
                status:99,
                sort:'latest'
            },
            list_all:[],
            list_temp:[],
            status_list: {
                all: {name: '全部', value: 99, count: 0},
                publish: {name: '已发布', value: 3, count: 0},
                wait_auth: {name: '待审核', value: 0, count: 0},
                reject: {name: '未通过', value: 2, count: 0},
            },
            show_page:false,
            uuid:'',
            show_detail:false,
            temp_purview:0,
            temp_is_top:false,
            curr_setting_item:null,
        }
    },
    filters:{
        status_filter(status){
            switch(status.toString()){
                case '0':
                    return '待审核';
                case '2':
                    return '未通过';

            }
        }
    },
    components:{
        ArticleDetail
    },
    computed:{
        total_page(){
            const {total_count,temp_count,currTab} = this;
            return currTab == 1 ? total_count : temp_count;
        },
        list(){
            const {currTab,list_all,list_temp} = this;
            switch(currTab.toString()){
                case '1':
                    return list_all;
                case '2':
                    return list_temp;
            }
        }
    },
    watch:{
        total_page(news,olds){
            console.log('news-total-page',news);
        },
        'query.status'(){
            this.query.page = 1
            this.onGetList();
        }

    },
    async mounted(){
        const {type,uuid} = this.$route.query;
        if(type) this.currTab = type;
        if(uuid){
            this.query.status = 0;
            this.uuid = uuid;
            this.show_detail = true;
        }
        console.log('this.query',this.query);
        await this.onGetList();
        await this.onGetTempList();
    },
    methods:{
        onOpenSetting(item){
            this.curr_setting_item = item;
            this.temp_purview = item.purview || 0;
            this.temp_is_top = !!item.is_top;
        },
        onSelectPermission(item, purview){
            this.temp_purview = purview;
            this.applySetting(item);
        },
        onToggleTop(val){
            this.temp_is_top = val;
            this.applySetting(this.curr_setting_item);
        },
        onCancelSetting(){
            this.curr_setting_item = null;
        },
        async applySetting(item){
            if(!item) return;
            try{
                await SetPostPermission({
                    uuid: item.uuid,
                    purview: this.temp_purview,
                    is_top: this.temp_is_top ? 1 : 0
                });
                this.$layer.msg('设置成功');
                this.onSearch();
            }catch(e){
                console.log('err-set-permission',e);
                this.$layer.msg(e.msg || '设置失败');
            }
        },
        applySettingDebounced: _.debounce(function(item){
            this.applySetting(item);
        }, 300),
        onArticleDetail(data){
            this.uuid = data.uuid.toString();
            this.show_detail = true;
        },
        onCloseArticleDetail(e){
            console.log('关闭弹窗');
            this.show_detail = false;
        },
        change_status(s) {
            this.query.status = s
        },
        onSortChange() {
            this.query.page = 1;
            this.onGetList();
        },
        onTabClick(type){
            this.show_page = false;
            this.currTab = type;
            // this.total_count = 0;
            this.list_all = [];
            this.list_temp = [];
            this.query = {
                keyword:"",
                page:1,
                limit:15,
                status:'99',
                sort:'latest'
            }
            if(this.currTab == 1){
                this.onGetList();
            }else{
                this.onGetTempList();
            }
        },
        onGetTempList:_.debounce(async function(){
            try{
                this.list_temp = [];
                const {query} = this;
                const {keyword,page,limit} = query;
                const {data} = await GetMyPostList({keyword,page,limit,status:-1});
                this.temp_count = data.count;
                if(!data.list.length) return;
                this.list_temp = data.list;
            }catch(e){
                console.log('ee',e);
            }finally{
                this.show_page = true;
            }
        },100),
        onGetList:_.debounce(async function(){
            try{
                this.show_page = false;
                // this.total_count = 0;
                this.list_all = [];
                const {data} = await GetMyPostList(this.query);
                this.list_all = data.list;
                this.total_count = data.count || 0;
                const response = await GetMyPostCount(this.query);
                for(let code in response.data){
                    this.status_list[code].count = response.data[code];
                }
                this.$forceUpdate();
            }finally{
                this.show_page = true;
            }
        },100),
        onPageChange(e){
            console.log("page-change",e);
            this.query.page = e;
            if(this.currTab == 1){
                this.onGetList();
            }else{
                this.onGetTempList();
            }
        },
        onItemDelete(item){
            console.log('delete-item',item);
            this.$DModal.confirm({
                content: '确认删除该笔记？',
                onOK: async () => {
                    try{
                        await DeletePosts({uuid:item.uuid});
                        const {currTab} = this;
                        this.list_all = [];
                        this.list_temp = [];
                        this.$layer.msg('删除成功');
                        this.query.page = 1;
                        currTab == 1 ? this.onGetList() : this.onGetTempList();
                    }catch(e){
                        console.log('eee-delete',e);
                    }
                }
            })
        },
        onItemEdit(item){
            console.log('edit-item',item);
            this.$router.push({name:'Posts',params:{uuid:item.uuid}})
        },
        onItemClick(item){
            console.log('click-item',item);
        },
        onSearch(){
            const {currTab} = this;
            switch(currTab){
                case 1:
                    this.onGetList();
                    break;
                case 2:
                    this.onGetTempList();
                    break;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import './mycreations.scss'
</style>
